








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloForfait, AloForfait } from '@/models/alo/AloForfait';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBaseForfait',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseForfait extends Vue {
  
  private original:AloForfait = getDefaultAloForfait()
  private modified:AloForfait = getDefaultAloForfait()
  private showDrawer = false
  private saving = false
    
  edit(item:AloForfait) {
    this.$store.myActions.ADM_FORFAIT_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloForfait(),...item}    
    this.modified = cloneDeep(this.original)
    
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get forfaitStatus() {
    return this.$store.myGetters.forfaitStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_FORFAIT_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.forfaitStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
